var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackrsIconMap } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { Email, Lock, Visibility, Add, Search } from '@mui/icons-material';
import { TextField, InputAdornment, FormHelperText, Box, FormLabel, } from '@mui/material';
import { appColors } from '../assets/appColors';
export var ICON_TYPES = {
    Email: Email,
    Search: Search,
    Lock: Lock,
    Visibility: Visibility,
    Add: Add,
    Phone: BackrsIconMap.IconPhone,
};
var getIcon = function (iconName, color, size) {
    if (color === void 0) { color = appColors.color.darkBlue; }
    var IconComponent = ICON_TYPES[iconName];
    return _jsx(IconComponent, { style: { color: color, fontSize: size } });
};
export var BackrsTextField = function (_a) {
    var value = _a.value, _b = _a.variant, variant = _b === void 0 ? 'SQUARE' : _b, type = _a.type, onChange = _a.onChange, icon = _a.icon, placeholder = _a.placeholder, label = _a.label, id = _a.id, name = _a.name, autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, inputProps = _a.inputProps, sx = _a.sx, error = _a.error, helperText = _a.helperText, onEnterPress = _a.onEnterPress, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var leftIcon = icon && (icon === null || icon === void 0 ? void 0 : icon.type) !== 'RIGHT_ICON' ? (_jsx(InputAdornment, { sx: { cursor: icon.onLeftIconClick ? 'pointer' : 'default' }, position: "start", onClick: icon.onLeftIconClick, children: getIcon(icon.leftIcon, icon.leftIconColor, icon.leftIconSize) })) : undefined;
    var rightIcon = icon && (icon === null || icon === void 0 ? void 0 : icon.type) !== 'LEFT_ICON' ? (_jsx(InputAdornment, { position: "end", sx: { cursor: icon.onRightIconClick ? 'pointer' : 'default' }, onClick: icon.onRightIconClick, children: getIcon(icon.rightIcon, icon.rightIconColor, icon.rightIconSize) })) : undefined;
    var inputStyle = variant === 'SQUARE' ? squaredInputStyle : roundedInputStyle;
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' && onEnterPress) {
            onEnterPress();
        }
    };
    return (_jsxs(Box, { width: "100%", children: [label && _jsx(FormLabel, { children: label }), _jsx(TextField, { margin: "dense", fullWidth: true, id: id, name: name, autoComplete: autoComplete, autoFocus: autoFocus, placeholder: placeholder, value: value, type: type, onChange: function (e) { return onChange(e.target.value); }, InputLabelProps: { shrink: false }, error: !!error, InputProps: {
                    startAdornment: leftIcon,
                    endAdornment: rightIcon,
                    sx: { width: '100%' },
                }, inputProps: inputProps, sx: __assign(__assign({}, inputStyle), sx), disabled: disabled, onKeyUp: handleKeyDown }), error && _jsx(FormHelperText, { error: true, children: error }), helperText && !error && _jsx(FormHelperText, { children: helperText })] }));
};
var squaredInputStyle = {
    borderRadius: 2,
    backgroundColor: appColors.neutral.mediumGray,
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'transparent',
        },
        '&:hover fieldset': {
            borderColor: 'transparent',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'transparent',
        },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '&.Mui-disabled .MuiSvgIcon-root': {
            opacity: 0.5,
        },
        '&.Mui-disabled svg': {
            opacity: 0.5,
        },
    },
    '&:has(.Mui-disabled)': {
        opacity: 0.5,
    },
};
var sharedAutoFillProps = {
    WebkitBoxShadow: "0 0 0 1000px ".concat(appColors.neutral.white, " inset"),
    WebkitTextFillColor: appColors.neutral.black,
    height: 8,
};
var roundedInputStyle = {
    borderRadius: 8,
    height: 40,
    justifyContent: 'center',
    backgroundColor: appColors.neutral.white,
    alignItems: 'center',
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'transparent',
        },
        '&:hover fieldset': {
            borderColor: 'transparent',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'transparent',
        },
    },
    '& input': {
        '&:-webkit-autofill': sharedAutoFillProps,
        '&:-webkit-autofill:hover': sharedAutoFillProps,
        '&:-webkit-autofill:focus': sharedAutoFillProps,
        '&:-webkit-autofill:active': sharedAutoFillProps,
    },
};
